import { useState } from 'react'
import Popup from 'src/Components/Popup'
import Input from 'src/Components/Form/Input'
import style from './style.module.scss'
import { IClientCreate } from 'src/utils/Interfaces/client.interface'

interface Props {
  handleClientAdditionalInfo: ({ baseInfo }: { baseInfo: string}) => void,
  setClientAdditionalInfoPopup: (value: boolean) => void,
  defaultData: IClientCreate
}
export const ClientAdditionalInfoPopup = ({ defaultData, handleClientAdditionalInfo, setClientAdditionalInfoPopup }: Props) => {
  const [info, setInfo] = useState(defaultData?.baseInfo || '')

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!info) return
    handleClientAdditionalInfo({
      baseInfo: info
    })
  }
  return (
    <Popup className={style.new_experiment} title="Edit client" closePopup={() => setClientAdditionalInfoPopup(false)}>
      <form onSubmit={handleSubmit}>
        <Input name="info" label="Base Info" value={info} onChange={(e) => setInfo(e.target.value)} />
        <button className="btn" type="submit">
          Add
        </button>
      </form>
    </Popup>
  )
}
